export default "__VITE_ASSET__CzSNUoP4__"